import { render, staticRenderFns } from "./EnderecoBox.vue?vue&type=template&id=59d10370&scoped=true"
import script from "./EnderecoBox.vue?vue&type=script&lang=js"
export * from "./EnderecoBox.vue?vue&type=script&lang=js"
import style0 from "./EnderecoBox.vue?vue&type=style&index=0&id=59d10370&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d10370",
  null
  
)

export default component.exports